/**
 * 08/2023 created
 */
import TopdataPbCategoryExtensionApiService from '../service/topdata-pb-category-extension-api.service'
import TopdataPbProductExtensionApiService from '../service/topdata-pb-product-extension-api.service'

Shopware.Service().register(
    'TopdataPbCategoryExtensionApiService',
    (container) => {
        const initContainer = Shopware.Application.getContainer('init');
        return new TopdataPbCategoryExtensionApiService(initContainer.httpClient, container.loginService);
    }
);

Shopware.Service().register(
    'TopdataPbProductExtensionApiService',
    (container) => {
        const initContainer = Shopware.Application.getContainer('init');
        return new TopdataPbProductExtensionApiService(initContainer.httpClient, container.loginService);
    }
);
